(() => {
  const wrapperId = 'trustpilot-widget-trustbox-0-wrapper';
  const widgetId = 'trustpilot-widget-trustbox-0';
  const mobile = window.matchMedia('(max-width: 749px)');
  const flowStyles = { position: 'static', top: 'auto', left: 'auto', width: '100%' };
  const snapshots = new WeakMap();
  let wrapper;
  let styleObserver;

  const sameStyle = (element, property, value, priority) =>
    element.style.getPropertyValue(property) === value &&
    element.style.getPropertyPriority(property) === priority;

  function updateFlow() {
    if (!wrapper) return;
    let original = snapshots.get(wrapper);

    if (mobile.matches) {
      if (!original) {
        original = {};
        snapshots.set(wrapper, original);
      }
      for (const [property, value] of Object.entries(flowStyles)) {
        if (!sameStyle(wrapper, property, value, 'important')) {
          // Preserve a later app update before applying the mobile presentation.
          original[property] = [
            wrapper.style.getPropertyValue(property),
            wrapper.style.getPropertyPriority(property)
          ];
          wrapper.style.setProperty(property, value, 'important');
        }
      }
    } else if (original) {
      for (const [property, [value, priority]] of Object.entries(original)) {
        if (!sameStyle(wrapper, property, flowStyles[property], 'important')) continue;
        if (value) wrapper.style.setProperty(property, value, priority);
        else wrapper.style.removeProperty(property);
      }
      snapshots.delete(wrapper);
    }
  }

  function bindWrapper() {
    const next = document.getElementById(wrapperId);
    if (!next || !next.querySelector(`#${widgetId}`)) return;
    if (next !== wrapper) {
      if (styleObserver) styleObserver.disconnect();
      wrapper = next;
      styleObserver = new MutationObserver(updateFlow);
      styleObserver.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
    }
    updateFlow();
  }

  function start() {
    bindWrapper();
    // Trustpilot can insert or replace its wrapper after the theme has loaded.
    new MutationObserver(bindWrapper).observe(document.body, { childList: true, subtree: true });
    if (mobile.addEventListener) mobile.addEventListener('change', bindWrapper);
    else mobile.addListener(bindWrapper);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
